import template from "./proxy-response-viewer.html";

function Controller($logger) {
	const ctrl = this;

	ctrl.$onInit = () => {
		ctrl.syncFromBody();
	};

	ctrl.$onChanges = (changes) => {
		if(changes && changes.response?.Data?.Body) {
			ctrl.syncFromBody();
		}
	};

	ctrl.syncFromBody = () => {
		if(!ctrl.response?.Data?.Body) {
			if(ctrl.response.Success !== undefined) {
				ctrl.action = "OPERATION_RESULT";
			}
			return;
		}
		// Derive fields from body if provided; allows parent to pass a single object.
		ctrl.action = ctrl.response.Data.Body.Action;
		ctrl.content = ctrl.response.Data.Body.Content;
		ctrl.mediaType = ctrl.response.Data.Body.MediaType;
		ctrl.filename = ctrl.response.Data.Body.Name;
	};
}

export default angular.module("vesl.components.proxy-response-viewer", []).component("proxyResponseViewer", {
	bindings: {
		response: "<"
	},
	controller: Controller,
	template
}).name;
